













import CtrlSearchCommonComponents from '@/components/common/control/CtrlSearchCommonComponents.vue';
import Vue from 'vue';

export default Vue.extend({
  name: 'ListShukaArea',
  components: {
    CtrlSearchCommonComponents,
  },

  props: {
    mukoUmuFlg: {
      type: Number,
    },
  },

  data: () => ({
    headers: [
      {
        text: 'コード',
        sortable: true,
        value: 'shukaAreaCd',
        width: 90,
      },
      {
        text: '集荷エリア名',
        sortable: true,
        value: 'shukaAreaMei',
        width: 170,
      },
      {
        text: 'コメント',
        sortable: true,
        value: 'shukaAreaComment',
        width: 340,
      },
    ],
    formatColName: 'shukaAreaCd',
  }),
});
